module.exports = __webpack_public_path__ + "img/business-img-economy.196e1e63.png";